var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMeetingRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104 24h304v32H104z",
    fill: "#68737f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128 56h256v168H128z",
    fill: "#d4e4f0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152 256h208v152H152z",
    fill: "#ba8b5d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120 336H24V232h32v56h64z",
    fill: "#529ddf"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56 288h16v24H56z",
    fill: "#4384c3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64 336h16v32H64z",
    fill: "#4f5761"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96 392a8 8 0 01-8-8v-8H56v8a8 8 0 01-16 0v-16a8 8 0 018-8h48a8 8 0 018 8v16a8 8 0 01-8 8z",
    fill: "#68737f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24 320h96v16H24z",
    fill: "#4384c3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M152 408h32v80h-32zM328 408h32v80h-32z",
    fill: "#9f764a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M207.378 368.645L187.056 328H176v-16h16a8 8 0 017.155 4.422l22.533 45.066z",
    fill: "#4f5761"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M184 352h48v32h-48z",
    fill: "#68737f"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M208.045 273.979L187.055 232H176v-16h16a8 8 0 017.155 4.422l23.2 46.4z",
    fill: "#4f5761"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M184 256h48v32h-48z",
    fill: "#68737f"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M304.622 368.645l-14.31-7.157 22.533-45.066A8 8 0 01320 312h16v16h-11.056z",
    fill: "#4f5761"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M328 384h-48v-32h48z",
    fill: "#68737f"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M303.155 275.578l-14.31-7.156 24-48A8 8 0 01320 216h16v16h-11.056z",
    fill: "#4f5761"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M328 288h-48v-32h48z",
    fill: "#68737f"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M120 440H24V336h32v56h64z",
    fill: "#529ddf"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M56 392h16v24H56z",
    fill: "#4384c3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M64 440h16v32H64z",
    fill: "#4f5761"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M96 496a8 8 0 01-8-8v-8H56v8a8 8 0 01-16 0v-16a8 8 0 018-8h48a8 8 0 018 8v16a8 8 0 01-8 8z",
    fill: "#68737f"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24 424h96v16H24z",
    fill: "#4384c3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M392 336h96V232h-32v56h-64z",
    fill: "#529ddf"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M440 288h16v24h-16z",
    fill: "#4384c3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M432 336h16v32h-16z",
    fill: "#4f5761"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M416 392a8 8 0 008-8v-8h32v8a8 8 0 0016 0v-16a8 8 0 00-8-8h-48a8 8 0 00-8 8v16a8 8 0 008 8z",
    fill: "#68737f"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M488 336h-96v-16h96z",
    fill: "#4384c3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M392 440h96V336h-32v56h-64z",
    fill: "#529ddf"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M440 392h16v24h-16z",
    fill: "#4384c3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M432 440h16v32h-16z",
    fill: "#4f5761"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M416 496a8 8 0 008-8v-8h32v8a8 8 0 0016 0v-16a8 8 0 00-8-8h-48a8 8 0 00-8 8v16a8 8 0 008 8z",
    fill: "#68737f"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M488 440h-96v-16h96z",
    fill: "#4384c3"
  })));
}

export default "data:image/svg+xml;base64,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";
export { SvgMeetingRoom as ReactComponent };